import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { createFrontendModule, TranslationBlueprint } from '@backstage/frontend-plugin-api';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder/alpha';

const scaffolderMessages = createTranslationMessages({
  ref: scaffolderTranslationRef,
  full: false,
  messages: {
    'aboutCard.launchTemplate': 'Executar Template',
    
    'actionsPage.title': 'Ações instaladas',
    'actionsPage.pageTitle': 'Criar um Novo Componente',
    'actionsPage.subtitle': 'Esta é a coleção de todas as ações instaladas',
    'actionsPage.content.emptyState.title': 'Nenhuma informação para exibir',
    'actionsPage.content.emptyState.description': 'Não há ações instaladas ou houve um problema de comunicação com o backend.',
    'actionsPage.content.searchFieldPlaceholder': 'Buscar por uma ação',
    'actionsPage.action.input': 'Entrada',
    'actionsPage.action.output': 'Saída',
    'actionsPage.action.examples': 'Exemplos',

    'fields.entityNamePicker.title': 'Nome',
    'fields.entityNamePicker.description': 'Nome único do componente',
    'fields.entityPicker.title': 'Entidade',
    'fields.entityPicker.description': 'Uma entidade do catálogo',
    'fields.entityTagsPicker.title': 'Tags',
    'fields.entityTagsPicker.description': 'Adicione tags relevantes, pressione "Enter" para adicionar novas tags. Formato válido: [a-z0-9+#] separados por [-], no máximo 63 caracteres',
    'fields.multiEntityPicker.title': 'Entidade',
    'fields.multiEntityPicker.description': 'Uma entidade do catálogo',
    'fields.myGroupsPicker.title': 'Entidade',
    'fields.myGroupsPicker.description': 'Uma entidade do catálogo',
    'fields.ownedEntityPicker.title': 'Entidade',
    'fields.ownedEntityPicker.description': 'Uma entidade do catálogo',
    'fields.ownerPicker.title': 'Proprietário',
    'fields.ownerPicker.description': 'O proprietário do componente',

    'fields.azureRepoPicker.organization.title': 'Organização',
    'fields.azureRepoPicker.organization.description': 'A organização a qual este repositório pertencerá',
    'fields.azureRepoPicker.project.title': 'Projeto',
    'fields.azureRepoPicker.project.description': 'O projeto a qual este repositório pertencerá',

    'fields.bitbucketRepoPicker.workspaces.title': 'Workspaces Permitidos',
    'fields.bitbucketRepoPicker.workspaces.inputTitle': 'Workspaces',
    'fields.bitbucketRepoPicker.workspaces.description': 'O workspace a qual este repositório pertencerá',
    'fields.bitbucketRepoPicker.project.title': 'Projetos Permitidos',
    'fields.bitbucketRepoPicker.project.inputTitle': 'Projetos',
    'fields.bitbucketRepoPicker.project.description': 'O projeto a qual este repositório pertencerá',

    'fields.gerritRepoPicker.owner.title': 'Proprietário',
    'fields.gerritRepoPicker.owner.description': 'O proprietário do projeto (opcional)',
    'fields.gerritRepoPicker.parent.title': 'Pai',
    'fields.gerritRepoPicker.parent.description': 'O projeto pai ao qual o repositório pertencerá',

    'fields.giteaRepoPicker.owner.title': 'Proprietário Disponível',
    'fields.giteaRepoPicker.owner.inputTitle': 'Proprietário',
    'fields.giteaRepoPicker.owner.description': 'Namespace Gitea onde este repositório pertencerá. Pode ser o nome da organização, grupo, subgrupo, usuário ou projeto.',

    'fields.githubRepoPicker.owner.title': 'Proprietário Disponível',
    'fields.githubRepoPicker.owner.inputTitle': 'Proprietário',
    'fields.githubRepoPicker.owner.description': 'A organização, usuário ou projeto a qual este repositório pertencerá',

    'fields.gitlabRepoPicker.owner.title': 'Proprietário Disponível',
    'fields.gitlabRepoPicker.owner.inputTitle': 'Proprietário',
    'fields.gitlabRepoPicker.owner.description': 'Namespace GitLab onde este repositório pertencerá. Pode ser o nome da organização, grupo, subgrupo, usuário ou projeto.',

    'fields.repoUrlPicker.host.title': 'Host',
    'fields.repoUrlPicker.host.description': 'O host onde o repositório será criado',
    'fields.repoUrlPicker.repository.title': 'Repositórios Disponíveis',
    'fields.repoUrlPicker.repository.inputTitle': 'Repositório',
    'fields.repoUrlPicker.repository.description': 'O nome do repositório',

    'listTaskPage.title': 'Listar tarefas de template',
    'listTaskPage.pageTitle': 'Tarefas de Templates',
    'listTaskPage.subtitle': 'Todas as tarefas que foram iniciadas',
    'listTaskPage.content.emptyState.title': 'Nenhuma informação para exibir',
    'listTaskPage.content.emptyState.description': 'Não há tarefas ou houve um problema de comunicação com o backend.',
    'listTaskPage.content.tableTitle': 'Tarefas',
    'listTaskPage.content.tableCell.taskID': 'ID da Tarefa',
    'listTaskPage.content.tableCell.template': 'Template',
    'listTaskPage.content.tableCell.created': 'Criado',
    'listTaskPage.content.tableCell.owner': 'Proprietário',
    'listTaskPage.content.tableCell.status': 'Status',

    'ownerListPicker.title': 'Proprietário da Tarefa',
    'ownerListPicker.options.owned': 'Possuídos',
    'ownerListPicker.options.all': 'Todos',

    'ongoingTask.title': 'Execução de',
    'ongoingTask.pageTitle.hasTemplateName': 'Execução de {{templateName}}',
    'ongoingTask.pageTitle.noTemplateName': 'Execução do Scaffolder',
    'ongoingTask.subtitle': 'Tarefa {{taskId}}',
    'ongoingTask.cancelButtonTitle': 'Cancelar',
    'ongoingTask.retryButtonTitle': 'Tentar Novamente',
    'ongoingTask.startOverButtonTitle': 'Começar Novamente',
    'ongoingTask.hideLogsButtonTitle': 'Ocultar Logs',
    'ongoingTask.showLogsButtonTitle': 'Mostrar Logs',
    'ongoingTask.contextMenu.hideLogs': 'Ocultar Logs',
    'ongoingTask.contextMenu.showLogs': 'Mostrar Logs',
    'ongoingTask.contextMenu.hideButtonBar': 'Ocultar Barra de Botões',
    'ongoingTask.contextMenu.retry': 'Tentar Novamente',
    'ongoingTask.contextMenu.showButtonBar': 'Mostrar Barra de Botões',
    'ongoingTask.contextMenu.startOver': 'Começar Novamente',
    'ongoingTask.contextMenu.cancel': 'Cancelar',

    'templateListPage.title': 'Criar um novo componente',
    'templateListPage.subtitle': 'Crie novos componentes de software usando templates padrão em sua organização',
    'templateListPage.pageTitle': 'Criar um novo componente',
    'templateListPage.templateGroups.defaultTitle': 'Templates',
    'templateListPage.templateGroups.otherTitle': 'Outros Templates',
    'templateListPage.contentHeader.registerExistingButtonTitle': 'Registrar Componente Existente',
    'templateListPage.contentHeader.supportButtonTitle': 'Crie novos componentes de software usando templates padrão. Diferentes templates criam diferentes tipos de componentes (serviços, websites, documentação, ...).',
    'templateListPage.additionalLinksForEntity.viewTechDocsTitle': 'Ver TechDocs',

    'templateWizardPage.title': 'Criar um novo componente',
    'templateWizardPage.subtitle': 'Crie novos componentes de software usando templates padrão em sua organização',
    'templateWizardPage.pageTitle': 'Criar um novo componente',
    'templateWizardPage.pageContextMenu.editConfigurationTitle': 'Editar Configuração',
  },
});

export const scaffolderTranslationModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    TranslationBlueprint.make({
      name: 'scaffolder-overrides',
      params: {
        resource: scaffolderMessages
      },
    }),
  ]
})